/**
 * The key of the state a request is SHOWN with. In the database a replaced request is plain `rechazada`
 * (D8: no enum change); the UI labels it "Reemplazada" instead, derived from the structured marker the API
 * exposes (`reemplazadaPor`), never from the text of the admin note.
 */
export function claveEstadoVisible(solicitud: { estado: string; reemplazadaPor?: number | null }): string {
	return solicitud.estado === 'rechazada' && solicitud.reemplazadaPor != null ? 'reemplazada' : solicitud.estado;
}

/**
 * Whether a request passes an admin state filter. The filter works on the SHOWN key, so a replaced request is
 * listed under "Reemplazada" and no longer under "Rechazada" (it is not a refusal).
 */
export function coincideFiltroEstado(
	solicitud: { estado: string; reemplazadaPor?: number | null },
	filtro: string,
): boolean {
	return filtro === 'todas' || claveEstadoVisible(solicitud) === filtro;
}
